import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { api } from "@/lib/api";

export default function VisitorCounter({ className = "" }) {
  const [count, setCount] = useState(null);
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    const seen = localStorage.getItem("ea_visitor");
    const call = seen ? api.get("/visitors") : api.post("/visitors/register");
    call
      .then(({ data }) => {
        setCount(data.count);
        if (!seen) localStorage.setItem("ea_visitor", "1");
      })
      .catch(() => setCount(null));
  }, []);

  useEffect(() => {
    if (!count) return;
    const start = Math.max(0, count - 60);
    const duration = 1400;
    const t0 = performance.now();
    let raf;
    const tick = (t) => {
      const p = Math.min(1, (t - t0) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(Math.round(start + (count - start) * eased));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [count]);

  if (count === null) return null;

  return (
    <motion.div
      data-testid="visitor-counter"
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 1.3 }}
      className={`inline-flex items-center gap-3 border border-white/15 bg-navy/40 px-5 py-3 backdrop-blur ${className}`}
    >
      <span className="h-2 w-2 animate-pulse bg-brand-magenta" />
      <span className="font-mono text-sm uppercase tracking-[0.2em] text-slate-400">
        Visitors
      </span>
      <span className="font-display text-2xl font-semibold text-white tabular-nums">
        {display.toLocaleString()}
      </span>
    </motion.div>
  );
}
